import { base64 } from 'ha/utils/base64';

export function parseListingId(listingIdEncoded: string) {
  try {
    const listingId = Number.parseInt(base64.atob(listingIdEncoded), 10);
    return listingId;
  } catch {
    return Number.NaN;
  }
}
